import fetch from '../../utils/fetchService';
import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
  replaceParams,
} from '../../utils/requestHelpers';

export const fetchE2eNotifications = async (onlyErrors = true) => await fetch(
  `${Config.endpoints.FETCH_E2E_NOTIFICATIONS}?onlyErrors=${onlyErrors ? 'Y' : 'N'}`
)
  .then(handleErrors({ errorMessage: 'Fetching e2e notifications failed' }))
  .then(parseAsJson);

export const updateE2eNotificationMasterFlag = async (jobId, errorMsgFlag) => await fetch(
  replaceParams(Config.endpoints.UPDATE_E2E_NOTIFICATION_MASTER, { jobId }),
  {
    method: 'PUT',
    body: JSON.stringify({ errorMsgFlag }),
  }
)
  .then(handleErrors({ errorMessage: 'Updating e2e notification failed' }));

export const updateE2eNotificationClientFlag = async (jobId, errorMsgFlag) => await fetch(
  replaceParams(Config.endpoints.UPDATE_E2E_NOTIFICATION_CLIENT, { jobId }),
  {
    method: 'PUT',
    body: JSON.stringify({ errorMsgFlag }),
  }
)
  .then(handleErrors({ errorMessage: 'Updating e2e notification failed' }));
